import axios from '@/axios'
import * as types from '../mutation-types';
import { emptyId } from '@/helpers/enums';

export default {
	namespaced: true,

	state: {
		statistics: [],
		providerStatistics: [],
		itemsStatistics: []
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate, ownerIds, forClient }) {
			const urlSearchParams = new URLSearchParams();
			const params = { fromDate, toDate, forClient };
			Object.keys(params).forEach(key => {
				if (![null, undefined].includes(params[key])) urlSearchParams.append(key, params[key]);
			})
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/statistics', {
				params: urlSearchParams
			}).then((data) => {
				commit(types.STORE_PROVIDER_STATISTICS, data);
				return data;
			})
		},

		fetchProviderStatistics({ commit }, { fromDate, toDate, ownerIds, forClient }) {
			const urlSearchParams = new URLSearchParams();
			const params = { fromDate, toDate, forClient };
			Object.keys(params).forEach(key => {
				if (![null, undefined].includes(params[key])) urlSearchParams.append(key, params[key]);
			})
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/statistics/provider', {
				params: urlSearchParams
			}).then((data) => {
				commit(types.STORE_PROVIDER_STATISTICS, data);
				return data;
			})
		},

		fetchItemStatistics({ commit }) {
			return axios.get('/Statistics/Dashboard').then((data) => {
				commit(types.STORE_ITEMS_STATISTICS, data)
				return data
			})
		},

		fetchAvailableToSellQuantities({ commit }) {
			return axios.get('/statistics/availableToSellQuantities').then((data) => {
				return data
			})
		},

		fetchAvailableToSellByOwners({ commit }, { ownerIds = [emptyId] } = {}) {
			const urlSearchParams = new URLSearchParams();
			ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			return axios.get('/statistics/availableToSellQuantitiesByOwnerGrouped', { params: urlSearchParams }).then((data) => data)
		},

		fetchExpectedActualQty({ commit }, { ownerIds = [emptyId] }) {
			const urlSearchParams = new URLSearchParams();
			ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			return axios.get('/statistics/actualAndExpectedQuantities', { params: urlSearchParams }).then((data) => data)
		},
	},

	mutations: {
		[types.STORE_STATISTICS](state, statistics) {
			state.statistics = statistics;
		},
		[types.STORE_PROVIDER_STATISTICS](state, providerStatistics) {
			state.providerStatistics = providerStatistics;
		},
		[types.STORE_ITEMS_STATISTICS](state, itemsStatistics) {
			state.itemsStatistics = itemsStatistics
		}
	},
}